import { LayoutGrid, List } from 'lucide-react'
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group'
import type { AdSelectionView } from './adSelectionTypes'

interface AdViewToggleProps {
    view: AdSelectionView
    onViewChange: (view: AdSelectionView) => void
}

export function AdViewToggle({ view, onViewChange }: AdViewToggleProps) {
    return (
        <ToggleGroup
            type="single"
            value={view}
            onValueChange={(value) => {
                if (value === 'grid' || value === 'list') {
                    onViewChange(value)
                }
            }}
            className="shrink-0 border border-border"
        >
            <ToggleGroupItem
                value="grid"
                aria-label="Creatives view"
                className="h-8 gap-1.5 px-3 text-xs"
            >
                <LayoutGrid className="size-3.5" />
                Creatives
            </ToggleGroupItem>
            <ToggleGroupItem
                value="list"
                aria-label="Performance view"
                className="h-8 gap-1.5 px-3 text-xs"
            >
                <List className="size-3.5" />
                Performance
            </ToggleGroupItem>
        </ToggleGroup>
    )
}
